export enum TYPE_TIMER {
  RESULT_LIST = 'resultList',
  FORM_PURCHASE = 'formPurchase',
}

export enum TYPE_TIMER_START {
  resultList = 10,
  formPurchase = 20,
}

export interface EachTimerStore {
  timer?: number
  isRunning?: boolean
  timerID?: NodeJS.Timeout
  startTimer?: number
}

export interface TimerStore {
  [TYPE_TIMER.FORM_PURCHASE]?: EachTimerStore
  [TYPE_TIMER.RESULT_LIST]?: EachTimerStore
}
